import { render, staticRenderFns } from "./ModalCheckoutRemoveDigitalItem.vue?vue&type=template&id=1c718711"
import script from "./ModalCheckoutRemoveDigitalItem.vue?vue&type=script&lang=js"
export * from "./ModalCheckoutRemoveDigitalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports